<template>
  <div class="account-content">
    <div class="d-flex flex-wrap w-100 vh-100 overflow-hidden">
      <!-- Left Column: Login Form -->
      <div
        class="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 col-12 col-md-6 bg-backdrop"
      >
        <Form
          @submit="submitData"
          :validation-schema="schema"
          v-slot="{ errors }"
          class="flex-fill"
        >
          <div class="mx-auto mw-450">
            <div class="text-center mb-4">
              <img
                src="@/assets/img/savor-logo.png"
                class="img-fluid"
                alt="Logo"
              />
            </div>
            <div class="mb-4">
              <h4 class="mb-2 fs-20">Sign In</h4>
              <p>Access the CRMS panel using your email and passcode.</p>
            </div>
            <!-- Email Field -->
            <div class="mb-3">
              <label class="col-form-label">Email Address</label>
              <div class="position-relative">
                <span class="input-icon-addon">
                  <i class="ti ti-mail"></i>
                </span>
                <Field
                  name="email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.email }"
                />
                <div class="invalid-feedback">{{ errors.email }}</div>
                <div class="emailshow text-danger" id="email"></div>
              </div>
            </div>
            <!-- Password Field -->
            <div class="mb-3">
              <label class="col-form-label">Password</label>
              <div class="pass-group">
                <Field
                  name="password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control pass-input mt-2"
                  :class="{ 'is-invalid': errors.password }"
                />
                <span @click="toggleShow" class="toggle-password">
                  <i
                    :class="{
                      'ti ti-eye': showPassword,
                      'ti ti-eye-off': !showPassword,
                    }"
                  ></i>
                </span>
                <div class="invalid-feedback">{{ errors.password }}</div>
                <div class="emailshow text-danger" id="password"></div>
              </div>
            </div>
            <!-- Remember Me & Forgot Password -->
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div class="form-check form-check-md d-flex align-items-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkebox-md"
                />
                <label class="form-check-label" for="checkebox-md">
                  Remember Me
                </label>
              </div>
              <div class="text-end">
                <router-link
                  to="/forgot-password"
                  class="text-primary fw-medium link-hover"
                >
                  Forgot Password?
                </router-link>
              </div>
            </div>
            <!-- Login Button -->
            <div class="mb-3">
              <button
                type="submit"
                class="btn btn-primary w-100"
                :disabled="isLoading"
              >
                Login
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm ms-2"
                ></span>
              </button>
            </div>
          </div>
        </Form>
      </div>

      <!-- Right Column: Image -->
      <div
        class="d-none d-md-flex align-items-center justify-content-center col-md-6 bg-light"
      >
        <img
          src="@/assets/img/authentication/login-img.png"
          class="img-fluid w-75"
          alt="Login Illustration"
        />
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import { ref } from "vue";
import { router } from "@/router";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
export default {
  components: {
    /* eslint-disable vue/no-reserved-component-names */
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
      isLoading: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async submitData(values) {
      try {
        this.isLoading = true;
        const apiUrl =
          process.env.VUE_APP_API_URL || "http://localhost:8000/api";

        const response = await fetch(`${apiUrl}/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(values),
        });
        const statusCode = response.status;
        const data = await response.json();
        if (statusCode == 200) {
          let token = data.contents.token;
          let expires_at = data.contents.expires_at;
          localStorage.setItem("bearer_token", token);
          localStorage.setItem("token_expiration", expires_at);
          this.$store.commit("setUser", data.contents?.user);
          this.$store.commit("setUserRoles", data.contents?.roles);
          this.$store.commit("setUserPermissions", data.contents?.permissions);
          await this.fetchNotifications();
          this.isLoading = false;
          router.push("/dashboard");
        } else if (statusCode == 400) {
          document.getElementById("email").innerHTML = data.message;
          this.isLoading = false;
        } else if (statusCode == 422) {
          const resError = data.errors;
          if ("password" in resError) {
            document.getElementById("password").innerHTML = resError.password;
          }
          if ("email" in resError) {
            document.getElementById("email").innerHTML = resError.email;
          }
          this.isLoading = false;
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        this.isLoading = false;
      }
    },

    async fetchNotifications() {
      const endpoint = `/all-leads-edit-requests`;
      const method = "get";
      try {
          const response = await http[method](endpoint);
          this.$store.commit('setSupervisorNotifications', response.data.contents);
      } catch (error) {
          console.error("Error fetching employees:", error);
      }
    },
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string()
        .required("Email is required")
        .email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });

    return {
      schema,
      checked: ref(false),
    };
  },
};
</script>
<style scoped>
.account-content {
  background: #f8f9fa;
}

.bg-backdrop {
  background: rgba(255, 255, 255, 0.8);
}

.bg-light {
  background-color: #f8f9fa;
}
</style>
